export const color_pallete_color_types = {
    gradient: "gradient",
    single: "single",
} as const;

export const DEFAULT_LIGHT_TEXT_COLOR = "#FBFBFE";

export const DEFAULT_DARK_TEXT_COLOR = "#272522";

export const DEFAULT_TEXT_COLOR = "#000000";
